import type { AgentSimpleResponseDTO } from "web_myplann/Infrastructure/Api/Api";

export const isSameAgent = (
	first: AgentSimpleResponseDTO,
	second: AgentSimpleResponseDTO | null | undefined,
): boolean => !!second && first.id === second.id && first.type === second.type;
